import React, {FC} from 'react';
import {useTranslation} from "react-i18next";
import { useAppDispatch, useAppSelector } from '../../hooks';
import { changeDeliveryOptions } from '../../stateReducers/deliverySlice';

const TransforceComment: FC = () => {
    const transforceComments = useAppSelector((state) => {
        return state.delivery.transforceComments;
    });
    const d = useAppDispatch();

    const {t} = useTranslation();
    return (
        <div className="form-group mb-6 flex flex-row">
            <div className="mb-3 w-full">
                <label htmlFor="insuranceAddress"
                       className="form-label inline-block mb-2 text-gray-700">{t('delivery.transforceCommentLabel')}</label>
                <textarea
                    className="
                                form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding
                                border border-solid border-gray-300
                                rounded
                                m-0
                                focus:text-gray-700 focus:bg-white focus:border-amber-400 focus:outline-none
                              "
                    onChange={(e) => d(changeDeliveryOptions({ transforceComments: e.target.value }))}
                    id="transforceComments"
                    name="transforceComments"
                    value={transforceComments}
                />
            </div>
        </div>
    );
};

export default TransforceComment;